import { documentsTypes } from "../constantes/actionTypes"

const initialState = []

export const typesOfDocuments = (state = initialState, action) => {
    switch (action.type) {
        case documentsTypes.GET_ALL_TYPE_OF_DOCUMENTS_SUCCESS:
            return action.payload
        case documentsTypes.GET_ALL__TYPE_OF_DOCUMENTS_FAILURE:
            return initialState
        default:
            return state
    }
}